
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeDialog extends Serenity.EntityDialog<PsDiscCouponTypeRow, any> {
        protected getFormKey() { return PsDiscCouponTypeForm.formKey; }
        protected getIdProperty() { return PsDiscCouponTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsDiscCouponTypeRow.nameProperty; }
        protected getService() { return PsDiscCouponTypeService.baseUrl; }
        protected getDeletePermission() { return PsDiscCouponTypeRow.deletePermission; }
        protected getInsertPermission() { return PsDiscCouponTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsDiscCouponTypeRow.updatePermission; }

        protected form = new PsDiscCouponTypeForm(this.idPrefix);

        constructor() {
            super();

            this.form.PartnerCompensatePc.element.parent();

            this.form.DiscCouponValueType.change(e => {
                var x = this.form.DiscCouponValueType.value;
             

               if (x == "0") {
                   Serenity.EditorUtils.setReadOnly(this.form.DiscCouponValue, true);
                //    Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensateAmt, !isPsDiscCPvalueType);
                //    Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensatePc, !isPsDiscCPvalueType);
               }
               else if (x == "1"){
                    Serenity.EditorUtils.setReadOnly(this.form.DiscCouponValue, false);
                    // Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensateAmt, isPsDiscCPvalueType1);
                    // Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensatePc, !isPsDiscCPvalueType1);
               }
               else if (x == "2") {
                    Serenity.EditorUtils.setReadOnly(this.form.DiscCouponValue, false);
                    // Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensateAmt, !isPsDiscCPvalueType2);
                    // Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensatePc, isPsDiscCPvalueType2);
               }else if (x == "3") {
                this.form.DiscCouponValueType.value = "0";
                Q.warning("ระบบอยู่ในระหว่างการพัฒนา ( ฟังชั่นนี้เป็นส่วนAdd-on โปรดติดต่อผู้ขายเพื่อเปิดการใช้งาน )");
            }});
        }

        // private get psDiscCoupontype() {
        //     return this.form.DiscCouponValueType.value != DiscCouponValueType.DiscValueType.toString();
        // }

        // private get psDiscCoupontype1() {
        //     return this.form.DiscCouponValueType.value != DiscCouponValueType.DiscValueType1.toString();
        // }

        // private get psDiscCoupontype2() {
        //     return this.form.DiscCouponValueType.value != DiscCouponValueType.DiscValueType2.toString();
        // }

    }
}